import React, { Component } from "react";

import styles from "./cmsUsers.module.scss";
import { withUsers } from "../../../shared/containers/containerUsers";
import { DataGrid } from "@mui/x-data-grid";
import getDates from "../../../shared/services/date.service";

class CmsUsersTable extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getRows() {
    const { users, blockUsersView } = this.props;

    return users
      .filter((x) => {
        if (!blockUsersView) {
          return !x.isBlocked;
        }

        return true;
      })
      .map((x) => {
        const dateCreation = new Date(Date.parse(x.dateCreation));
        const dateLastSignIn = new Date(Date.parse(x.dateLastSignIn));

        return {
          ...x,
          companyId: x.company.id,
          company: x.company.title,
          roleTitle: x.role.title,
          companyOwnershipArea: x.company.ownershipArea.title,
          dateCreation: getDates.getDateFormat12(
            new Date(dateCreation.setHours(-new Date().getTimezoneOffset() / 60 + dateCreation.getHours()))
          ),
          dateLastSignIn: getDates.getDateFormat12(
            new Date(dateLastSignIn.setHours(-new Date().getTimezoneOffset() / 60 + dateLastSignIn.getHours()))
          ),
        };
      });
  }

  getColumns() {
    const renderEmailCell = (params) => {
      return (
        <a href={`/cms/users/${params.row.id}`} target="_blank" rel="noreferrer">
          {params.row.email}
        </a>
      );
    };

    const renderCompanyTitleCell = (params) => {
      return (
        <a href={`/cms/companies/${params.row.companyId}`} target="_blank" rel="noreferrer">
          {params.row.company}
        </a>
      );
    };

    return [
      {
        field: "email",
        headerName: "Email",
        renderCell: renderEmailCell,
        width: 250,
      },
      {
        field: "title",
        headerName: "ФИО",
        width: 250,
      },
      {
        field: "roleTitle",
        headerName: "Роль",
        width: 150,
      },
      {
        field: "dateCreation",
        headerName: "Создан",
        width: 160,
      },
      {
        field: "dateLastSignIn",
        headerName: "Вход",
        width: 160,
      },
      {
        field: "isBlocked",
        headerName: "Заблокирован",
        type: "boolean",
        width: 100,
      },
      {
        field: "company",
        headerName: "Компания",
        renderCell: renderCompanyTitleCell,
        width: 350,
      },
      {
        field: "companyOwnershipArea",
        headerName: "Область владения",
        width: 200,
      },
    ];
  }

  render() {
    return (
      <div className={styles.cmsUserTableCoontainer}>
        <DataGrid
          rowHeight={30}
          ref={"DataGrid"}
          disableColumnSelector={true}
          disableColumnFilter={true}
          localeText={{
            columnMenuUnsort: "По умолчанию",
            columnMenuSortAsc: "По возрастанию",
            columnMenuSortDesc: "По убыванию",
            footerRowSelected: (count) => `Cтрок выбранно: ${count}`,
          }}
          rows={this.getRows()}
          columns={this.getColumns()}
          disableRowSelectionOnClick
        />
      </div>
    );
  }
}

export default withUsers(CmsUsersTable);
